import { LOGIN, USERDATA } from '../actions/Types'

const initialState = {
    loggedIn: false,
    userdata: undefined,
}

const Reducers = (state=initialState,action) => {
  switch(action.type){
    case LOGIN:
        return {
            ...state,
            loggedIn: action.data
        }
    case USERDATA:
        return {
            ...state,
            userdata: action.data
        }
    default:
        return state;        
  }
}

export default Reducers